import React, { useState } from "react";
import linkedin from "./assets/linkdein.png";
import leetcode from "./assets/leetcode.png";
import { GoMail } from "react-icons/go";
import "./contact.css";
import ContactModal from "./contactmodal";

function Contact() {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div>
      <div class="responsive-map">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d906693.5723699463!2d74.07208659092214!3d26.91243359587788!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x396db5d08b6b15e1%3A0x5dfed5b3b5b4b62!2sJaipur%2C%20Rajasthan%2C%20India!5e0!3m2!1sen!2sin!4v1710123456789"
          width="600"
          height="450"
          allowfullscreen
          loading="lazy"
          title="map"
          referrerpolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>

      <div className="mailcontainer">
        <h2 className="h2 article-title">Let's Connect</h2>
        <div className="contactbox">
          <div className="icon-box-mail" onClick={() => setIsOpen(true)}>
            <GoMail className="icons" style={{ color: "hsl(45, 100%, 72%)" }} />
          Contact
          </div>
          {isOpen && <ContactModal closeModal={() => setIsOpen(false)} />}
        <a href="mailto:thakareradha2001@gmail.com">
          <div className="icon-box-mail">
            <GoMail className="icons" style={{ color: "hsl(45, 100%, 72%)" }} />
            Mail
          </div>
        </a>
        </div>
      </div>

      <div className="socialcontainercontact">
        <h2 className="h2 article-title">Also View</h2>

        <div className="blog-posts-list">
          <div className="blog-post-item">
            <a
              href="https://www.linkedin.com/in/radha-thakare/"
              className="custom-link"
            >
              <div className="blog-banner-box">
                <img src={linkedin} alt="Logo" />
              </div>
              <div className="blog-content">
                <div className="blog-meta">
                  <p className="blog-category">Linkdein</p>

                  <time datetime="2022-02-23">-radha-thalare</time>
                </div>
              </div>
            </a>
          </div>
          <div className="blog-post-item">
            <a
              href="https://leetcode.com/radhathakare/"
              className="custom-link"
            >
              <div className="blog-banner-box">
                <img src={leetcode} alt="Logo" />
              </div>
              <div className="blog-content">
                <div className="blog-meta">
                  <p className="blog-category">Leetcode</p>

                  <time datetime="2022-02-23">-radhathakare</time>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
